<template>
  <div class="rule-wrap">
    <h3>用户注册协议</h3>
    <div class="rule-cont">
      <p>欢迎您与宁波商量信息技术有限公司（以下简称“宁波商量”）共同签署本《用户注册协议》（下称“本协议”）</p>
      <p><span>【慎重阅读】</span>您在注册或登录饷店官方网站之前，应当认真阅读本协议。<em>请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线进行标识，您应重点阅读。</em>如您对协议有任何疑问，可向饷店官方网站客服咨询。</p>
      <p><span>【特别提示】</span>当您按照注册/登录页面提示，阅读并同意协议且完成全部注册程序后，即表明您已充分阅读、理解并接受本协议的全部内容，本协议立即生效，您亦成为饷店官方网站“用户”。<em>阅读过程中，如果您不同意本协议及其补充协议中任意条款约定，您应立即停止登录程序或立即退出饷店官方网站。</em></p>
      <h4>一、账号注册与注销</h4>
      <p>1、您通过输入有效手机号码以及短信验证码后进行注册/登陆饷店官方网站。</p>
      <p>2、您确认，在注册/登录或使用饷店官方网站时，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。</p>
      <p>3、如您代表一家公司或其他法律主体，则您声明和保证，您有权使该公司或该法律主体受本协议的约束。此外，您还需确保您不是任何国家、国际组织或者地域实施的贸易限制、制裁或其他法律、规则限制的对象，否则您可能无法正常注册/登录或使用饷店官方网站。</p>
      <p>4、您可以向饷店官方网站客服申请饷店平台账号注销。申请过程中，您应当认真阅读《注销协议》以及饷店官方网站作出的风险提示并同意确认。如果您不同意相关任何条款或不同意放弃相关权益，请您立即停止账号注销程序。如您对《注销协议》有任何疑问，可联系饷店官方网站客服。</p>
      <p>5、注销账号后，您将无法再使用该账户，也将无法找回该账号以及与账号相关的任何内容或信息，包括但不限于：</p>
      <p>（一）您将无法继续使用该账号进行登录；</p>
      <p>（二）您账号的个人资料、历史消息或交易信息都将无法找回。</p>
      <h4>二、饷店SaaS软件购买和使用</h4>
      <p>1、饷店SaaS软件是由宁波商量自主研发并运营的电商店铺管理工具，具体功能详见饷店官方网站。</p>
      <p>2、您注册/登录后，可在线购买饷店SaaS软件（个人版/企业版），在线完成支付，订单成立并立即生效。</p>
      <p><em>3、饷店SaaS软件一经购买，立即以您注册/登陆的手机号码为账号，开通饷店店铺管理系统后台（网址：https://console.xiangtuan.xyz/login）以及与饷店SaaS软件产品功能相关联产品的账号。您可以按照购买后操作引导，进入后台管理系统登录页面或其他关联产品注册/登录页面，以手机号码短信验证的方式直接登录使用。</em></p>
      <p>4、您使用饷店SaaS软件应当在首次登录饷店店铺管理系统后台时，认真查阅《饷店SaaS软件许可及服务协议》并点击同意，如对《饷店SaaS软件许可及服务协议》内容有异议，可联系饷店官方网站客服咨询或解释。</p>
      <p>5、您在使用饷店SaaS软件的过程中，应当严格遵守饷店SaaS软件使用规则和流程，如果因您本人操作错误或失误，使您遭受损失，宁波商量不承担任何责任。对宁波商量造成损失的，由您承担赔偿责任。</p>
      <p>6、您不得独自或与任何第三方对饷店SaaS软件系统进行翻制、复制、解密、反编译、反汇编和其他反向工程，否则宁波商量有权追究您的法律责任和要求经济损失赔偿。</p>
      <h4>三、用户信息的保护及授权</h4>
      <p>1、宁波商量非常重视用户个人信息（即能够独立或与其他信息结合后识别用户身份的信息）的保护，对于您提供、发布及在使用饷店SaaS软件功能中形成的除个人信息外的文字、图片、视频、音频等非个人信息，<span>在法律规定的保护期限内您免费授予宁波商量及其关联公司获得全球排他的许可使用权利及再授权给其他第三方使用并可以自身名义对第三方侵权行为取证及提起诉讼的权利。您同意宁波商量及其关联公司存储、使用、复制、修订、编辑、发布、展示、翻译、分发您的非个人信息或制作其派生作品，并以已知或日后开发的形式、媒体或技术将上述信息纳入其它作品内。</span></p>
      <p>2、饷店官网或饷店SaaS软件店铺管理系统后台账号信息一经注销，用户信息立即被删除，但是以下情形除外：</p>
      <p>（一）按照国家法律法规规定，您与商家达成的商品交易中的商品和服务信息、交易信息保存时间自交易完成之日起不少于三年，符合上述条件的相关信息，包括但不限于订单记录、支付信息、物流信息等；</p>
      <p>（二）应国家监管部门强制性要求保留的信息；</p>
      <p>（三）为保护您的利益，而暂缓删除的；</p>
      <p>（四）相关信息删除，将侵犯国家利益、公共利益或其他第三方利益的。</p>
      <h4>四、有限责任</h4>
      <p>1、您了解并同意，鉴于现有技术水平和客观条件的限制，宁波商量将采取一切可能的技术手段保持您使用饷店SaaS软件所涉技术的安全和稳定性，但不作任何承诺或保证。</p>
      <p><em>2、宁波商量依照法律规定履行基础保障义务，但对于下述原因导致损失或权益侵害的，宁波商量，不因此承担任何责任：</em></p>
      <p>（一）因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；</p>
      <p>（二）因互联网网络连接故障，电力供应故障，电脑、通讯网络故障等公共服务因素或第三人因素；</p>
      <p><em>（三）在宁波商量已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素；</em></p>
      <p><em>（四）为符合国家法律规定或合规性要求，对饷店进行合理优化或调整。</em></p>
      <h4>五、通知和送达</h4>
      <p><span>1、您在注册成为饷店官方网站用户时绑定的手机号码为您的联系方式，您有义务保证联系方式保持可以被联系的状态。宁波商量也视为您的有效联系方式。宁波商量将可能通过上述联系方式发布通知，此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。</span></p>
      <p>2、宁波商量通过上述联系方式向您发出通知，其中以电子方式发出的书面通知，包括但不限于在饷店官方网站公告，向您提供的联系电话发送手机短信，按照提供联系地址交邮后的第五个自然日即视为送达。</p>
      <p>3、对于在店铺内因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。</p>
      <h4>六、协议的终止</h4>
      <p>1、您有权通过以下方式终止本协议：注销您的账号的；</p>
      <p>2、本协议终止后，宁波商量仍享有下列权利：</p>
      <p>（一）根据国家法律法规或本协议的约定，继续保存您留存于饷店官方网站的相关信息；</p>
      <p>（二）对于您过往的违约行为，宁波商量仍可依据本协议向您追究违约责任。</p>
      <h4>七、法律适用、管辖与其他</h4>
      <p><em>1、本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及/或行业惯例。</em></p>
      <p>2、因您注册、登录饷店官方网站以及站内交易发生争议，由宁波商量与您协商解决。协商不成时，任何一方均可向被告所在地具有管辖权的人民法院提起诉讼。</p>
      <p>3、本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。</p>
      <p>4、本协议于2020年1月15日进行公示，自2020年1月22日起生效。</p>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped lang="less">
  .rule-wrap {
    width: 100%;
    padding-bottom: 90px;
    overflow: auto;
    h3 {
      font-size:36px;
      font-family:PingFang-SC-Heavy,microsoft yahei,arial,hiragino sans gb;
      font-weight:800;
      color:rgba(43,46,51,1);
      line-height:50px;
      padding: 60px 0 30px;
    }
    .rule-cont {
      background:rgba(247,247,247,1);
      width: 1000px;
      margin: 0 auto;
      padding: 55px 60px;
      font-size:16px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(43,46,51,1);
      line-height:29px;
      p {
        text-align: left;
      }
      em {
        font-style: normal;
        text-decoration: underline;
        color: #2B2E33;
        font-family:PingFangSC-Medium;
        font-weight: bold;
      }
      span, h4 {
        color: #2B2E33;
        font-weight: bold;
      }
      h4 {
        text-align: left;
        margin-top: 35px;
      }
    }
  }
</style>
